import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isSpatialLayerDynamic } from '@rsos/components/capstone/common/Map/utils/spatialLayersHelpers';
import { gspx } from '@rsos/gainsight';
import { toggleSpatialLayer } from '../../actions/spatialLayers';
import { trackAirAmbulanceLayerToggle } from '../../gainsightTrackings/airAmbulanceTrackings';
import { LayerCheckboxProps, RootState } from './LayerCheckbox.types';
import NormalizedLayerCheckbox from './NormalizedLayerCheckbox';

const STATIC_LAYERS_CARD = 'staticLayersCard';

declare const closeCard: (cardName: string) => {
  type: string;
  payload: string;
};
declare const setMapCardData: (data: unknown) => {
  type: string;
  payload: unknown;
};

const AIR_AMBULANCE_HELICOPTER_DYNAMIC_LAYER = 'gmr_air';

/**
 * Component for handling the checkbox of a spatial layer
 */
const LayerCheckbox: React.FC<LayerCheckboxProps> = ({ layer }) => {
  const dispatch = useDispatch();
  const isLayerDynamic = isSpatialLayerDynamic(layer);
  const layerID = layer.id;
  const layerKey = layer.key;
  const layerData = useSelector(
    (state: RootState) => state.mapCard?.mapCardData?.layerData,
  );
  const { irpVersion } = useSelector((state: RootState) => state.sinatra.irp);

  const handleCheckboxOnChange = useCallback(() => {
    // layer.isChecked is in previous state here before reset
    const onOffText = layer.isChecked ? 'off' : 'on';
    const { name, source } = layer;

    if (!isLayerDynamic && source === layerData?.source) {
      dispatch(closeCard(STATIC_LAYERS_CARD));
      dispatch(setMapCardData(null));
    } else {
      //TODO: add handling for dynamic layers
    }

    gspx.trackCustomEvent('Data Map', {
      irpVersion,
      name: `Turn ${onOffText} ${name}`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
    });

    if (layerKey === AIR_AMBULANCE_HELICOPTER_DYNAMIC_LAYER) {
      trackAirAmbulanceLayerToggle({
        layerId: AIR_AMBULANCE_HELICOPTER_DYNAMIC_LAYER,
        isVisible: !layer.isChecked,
      });
    }

    dispatch(toggleSpatialLayer(layerKey, isLayerDynamic, !layer.isChecked));
  }, [
    dispatch,
    layer,
    layerKey,
    isLayerDynamic,
    layerData?.source,
    irpVersion,
  ]);

  // Regular single checkbox for layers without sublayers or non-GIS layers
  return (
    <NormalizedLayerCheckbox
      layer={layer}
      layerID={layerID}
      handleCheckboxOnChange={handleCheckboxOnChange}
    />
  );
};

export default LayerCheckbox;
